import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/supplier/$orgId/')({
  beforeLoad: ({ params }) => {
    throw redirect({ to: '/supplier/$orgId/dashboard', params, replace: true });
  },
});
